import React from 'react'
import { checkTextTranslation, checkTranslation, priceStandardView, translate } from '../../utils/useful'
import HttpServices from '../../utils/Http.services'
import TableViewer from '../TableViewer'
import { nanoid } from 'nanoid'

class UnpaidInvoicesInput extends React.Component {
    state = {
        // fullAmount: 10
        invoiceHeaders: [
            { key: 'invoice.date', type: 'DateInput', col: '6', information: { label: '{{lang}}applets.accounting.invoiceDate', placeholder: '{{lang}}applets.accounting.invoiceDate', required: true }, showMain: true },
            { key: 'invoice.id', type: 'TextInput', col: '12', information: { label: '{{lang}}number', placeholder: '{{lang}}number', required: false, disabled: true }, showMain: true },
            // { key: 'mode', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Payment mode', required: true, type: 'local', default: '0', items: [{ title: "{{lang}}Cash", value: 'C', color: '#789' }, { title: "{{lang}}Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },
            { key: 'invoice.amounts.totals.final', type: 'PriceInput', col: '12', information: { label: '{{lang}}Invoice Amount', placeholder: '{{lang}}Invoice Amount', required: false, disabled: true }, showMain: true },
            { key: 'invoice.balanceDue', type: 'PriceInput', col: '12', information: { label: '{{lang}}Amount Due', placeholder: '{{lang}}Amount Due', required: false, disabled: false }, showMain: true },
            { key: 'amount', type: 'PriceInput', col: '12', information: { label: '{{lang}}amount', placeholder: '{{lang}}Payment', required: false, disabled: false, inplaceEditable: true, changeFunction: 'paymentValueChanged' }, showMain: true },
        ],
        paymentValues: {},

    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            if (value == '') {
                value = null
            }
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

    componentDidMount() {
        this.fetchInvoices()


        // console.log('this.props.data', this.props?.data)
    }

    componentDidUpdate(prevProps, prevState) {

        let triggerKey = this.props.header?.information?.triggerKey
        let targetKey = this.props.header?.information?.targetKey

        if ((prevProps.fullData ? prevProps.fullData[triggerKey] : null) != (this.props.fullData ? this.props.fullData[triggerKey] : null)) {

            this.fetchInvoices()

        }


        if ((prevProps.fullData ? prevProps.fullData[targetKey] : null) != (this.props.fullData ? this.props.fullData[targetKey] : null)) {

            if (this.state.paymentValues['*'] != (this.props.fullData ? this.props.fullData[targetKey] : null)) {
                this.amountChanged((this.props.fullData ? this.props.fullData[targetKey] : null) ?? 0)
            }


        }


    }


    focus = () => {
        this.input.focus()
    }
    selectHandler = () => {

    }


    changeReceiveFullAmount = (e) => {
        let checked = e.target.checked
        // console.log(checked)
        // let payment = { ...this.state.payment }
        // if (!payment) {
        //     payment = {}
        // }
        let amount = 0

        if (checked) {
            amount = Number(this.state.fullAmount)
        } else {
            amount = 0
        }

        this.setState({}, () => {
            this.amountChanged(amount, !checked)
        })
    }



    amountChanged(amount, clear) {
        // console.log("amountChanged")
        // console.log(amount)
        let remained = amount
        if (!remained) {
            remained = 0
        }
        let paymentValues = {}
        let invoices = this.state.invoices ? JSON.parse(JSON.stringify(this.state.invoices)) : []

        if (Array.isArray(invoices)) {

            for (let i = 0; i < invoices.length; i++) {

                const invoice = invoices[i];
                if (clear) {
                    paymentValues[i] = 0
                } else {
                    if (invoice.balanceDue <= remained) {
                        paymentValues[i] = invoice.balanceDue ?? 0
                    } else {
                        paymentValues[i] = remained ?? 0
                    }
                    remained = remained - Number((paymentValues[i] ?? 0))
                }
                invoices[i].amount = paymentValues[i] ?? 0

            }

        }


        for (const [key, value] of Object.entries(paymentValues)) {

            if (!paymentValues['*']) {
                paymentValues['*'] = 0
            }

            paymentValues['*'] = paymentValues['*'] + value
        }

        // let payment = this.state.payment ? JSON.parse(JSON.stringify(this.state.payment)) : {}


        // payment.amount = amount
        // if (!payment.amount) {
        //     payment.amount = 0
        // }



        this.setState({ paymentValues, invoices }, () => {
            this.changeValue()

        })


        // this.receiveFullAmount.checked = (amount == this.state.fullAmount)
    }



    fetchInvoices = () => {
        // console.log("fetchinvoices")
        this.setState({ isLoading: true, fullAmount: null, invoices: [], paymentValues: {}, errors: {} })

        let triggerKey = this.props.header?.information?.triggerKey
        let customer = this.props.fullData[triggerKey]

        // console.log("customer", customer)
        if (customer) {



            // let paymentInvoices = []

            // if (this.state.payment?.invoices) {
            //     this.state.payment.invoices.forEach(element => {
            //         // console.log(element)
            //         paymentInvoices.push((typeof element.invoice == 'object' ? element.invoice._id : element.invoice))
            //     });
            // }

            let body = { applet: this.props.variables?.appletId, customer, }
            // invoices: paymentInvoices

            if (this.props.fullData?._id && Array.isArray(this.props.data)) {
                body.invoices = []
                for (let i = 0; i < this.props.data.length; i++) {
                    const element = this.props.data[i];
                    body.invoices.push(element.invoice?._id ?? element.invoice)
                }
            }


            HttpServices.request("getCustomerPendingInvoices", body, (fetchResult, fetchError) => {

                this.setState({ isLoading: false })
                // console.log(fetchResult)
                // console.log(fetchError)

                if (fetchError) {
                    // console.log("HERE")
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }

                if (fetchResult.info) {

                    let fullAmount = 0
                    let invoices = []
                    if (Array.isArray(fetchResult.info)) {

                        for (let i = 0; i < fetchResult.info.length; i++) {
                            const invoice = fetchResult.info[i]
                            let invoiceAmount = 0

                            // if (paymentInvoices.includes(invoice._id)) {
                            //     if (this.state.payment?.invoices) {
                            //         this.state.payment.invoices.forEach(element => {

                            //             let id = typeof element.invoice == 'object' ? element.invoice._id : element.invoice
                            //             if (id == invoice._id) {
                            //                 invoiceAmount = element.amount
                            //             }
                            //         });
                            //     }

                            //     invoice.balanceDue = invoice.balanceDue + invoiceAmount
                            // }

                            fullAmount = fullAmount + (invoice.balanceDue ?? 0)

                            invoices.push({ id: nanoid(), invoice, amount: 0 })
                        }

                    }


                    // let invoices = [...fetchResult.info]
                    let paymentValues = {}
                    paymentValues['*'] = 0

                    // if (Array.isArray(this.state.payment?.invoices)) {

                    //     this.state.payment.invoices.forEach((element, index) => {
                    //         invoices.forEach(invoice => {
                    //             let id = typeof element.invoice == 'object' ? element.invoice._id : element.invoice
                    //             if (invoice._id == id) {
                    //                 paymentValues[index] = element.amount
                    //                 paymentValues['*'] = paymentValues['*'] + element.amount
                    //                 invoice.amount = element.amount
                    //             }
                    //         })


                    //     })


                    // }



                    if (this.props.fullData?._id) {
                        if (this.props.data && Array.isArray(this.props.data) && Array.isArray(invoices)) {

                            for (let i = 0; i < invoices.length; i++) {
                                const rinvoice = invoices[i];
                                for (let j = 0; j < this.props.data.length; j++) {
                                    const one = this.props.data[j];
                                    if ((one.invoice?._id ?? one.invoice) == rinvoice.invoice?._id) {
                                        rinvoice.amount = one.amount
                                    }
                                }
                            }

                        }

                    }


                    this.setState({ paymentValues, invoices, fullAmount }, () => {

                        if (this.props.fullData?._id) {

                            return
                        }
                        let targetKey = this.props.header?.information?.targetKey

                        if (this.state.paymentValues['*'] != (this.props.fullData ? this.props.fullData[targetKey] : null)) {
                            this.amountChanged((this.props.fullData ? this.props.fullData[targetKey] : null) ?? 0)
                        }


                    })
                }

            })
        } else {
            this.setState({ invoices: [], paymentValues: {}, fullAmount: 0 })
        }


    }



    functionsHandler = (type, name, data, extra, cb) => {

        // functionsHandler = (reference, key, data, extra, index) => {
        // console.log(type, name, data, extra, cb)
        if (this[name]) {
            // this[name](key, data, extra, index, reference)
            this[name](data, extra, cb)
        }
    }


    paymentValueChanged = (data, extra) => {

        // console.log("paymentValueChanged", data, extra)

        let invoices = this.state.invoices ? JSON.parse(JSON.stringify(this.state.invoices)) : []
        invoices[extra.index].amount = data

        let paymentValues = this.state.paymentValues
        if (!paymentValues) {
            paymentValues = {}
        }

        let oldValue = paymentValues[extra?.index]
        paymentValues[extra?.index] = data


        if (!paymentValues['*']) {
            paymentValues['*'] = 0
        }

        paymentValues['*'] = paymentValues['*'] + (data - (oldValue ?? 0))


        this.setState({ paymentValues, invoices }, () => {
            let targetKey = this.props.header?.information?.targetKey

            // console.log("paymentValues", paymentValues,targetKey)

            this.props.changeValue(targetKey, paymentValues['*'], this.props.extra)
            setTimeout(() => {
                this.changeValue()
            }, 50);
        })


    }


    changeValue = (key, value, extra) => {

        let list = []

        for (let i = 0; i < this.state.invoices.length; i++) {
            const rinvoice = this.state.invoices[i];
            if (rinvoice.amount) {
                list.push({ invoice: (rinvoice.invoice?._id ?? rinvoice.invoice), amount: rinvoice.amount })
            }
        }

        // console.log(this.props.header?.key, list)

        this.props.changeValue(this.props.header?.key, list, this.props.extra)


    }


    render() {

        let targetKey = this.props.header?.information?.targetKey

        let excess = (this.props.fullData ? (this.props.fullData[targetKey] ?? 0) : 0) - (this.state.paymentValues['*'] ?? 0)

        // console.log(this.state.paymentValues,this.props.fullData[targetKey])
        return (
            <div className="w-100 h-100 flexc "  >
                <div className="pb-3 pt-0  w-100" >
                    {/* <p className="text-big mb-3 ">{translate("Unpaid Invoices")}</p> */}

                    <TableViewer headers={this.state.invoiceHeaders} data={this.state.invoices} top={0} functionsHandler={this.functionsHandler} />


                    <div className="d-flex  justify-content-end mt-3 mb-4">
                        <div className="d-flex" style={{ backgroundColor: '#f6f6f6', borderRadius: 8, padding: '15px 20px' }}>
                            <div className="text-center" style={{ maxWidth: '250px', width: '100%', color: '#000' }}>
                                <p className="text-small text-end mb-2 text-bold">{translate("Invoices' Payments")}</p>
                                <p className="text-small text-end mb-2">{translate("Amount Received")}</p>
                                {/* <p className="text-small text-end mb-2">{translate("Amount used for Payments")}</p> */}
                                {/* <p className="text-small text-end mb-2">{translate("Amount Refunded")}</p> */}
                                <p className="text-small text-end mb-2">{translate("Amount in Excess")}</p>
                                {/* <p className="text-small text-end mb-2  text-bold">{translate("Total")}</p>
                                                        <p className="text-small text-end mb-2" style={{ color: '#ee5050' }}>{translate("Payments made")}</p>
                                                        <p className="text-small text-end mb-2" style={{ borderTop: '1px solid #eee', padding: '5px 0px' }}>{translate("Balance due")}</p> */}



                            </div>

                            <div className="text-center" style={{ width: '150px' }}>
                                <p className="text-small text-end mb-2 text-bold">{priceStandardView(this.state.paymentValues['*'] ?? 0)}</p>
                                <p className="text-small text-end mb-2">{priceStandardView((this.props.fullData ? this.props.fullData[targetKey] : null) ?? 0)}</p>
                                {/* <p className="text-small text-end mb-2">{this.state.payment?.list?.tax}</p> */}
                                {/* <p className="text-small text-end mb-2">{this.state.payment?.list?.shipping}</p> */}
                                <p className="text-small text-end mb-2" style={{ color: excess ? '#ee5050' : '#000' }}>{priceStandardView(excess)}</p>
                                {/* <p className="text-small text-end mb-2 text-bold">{this.state.payment?.list?.total}</p>
                                                        <p className="text-small text-end mb-2" style={{ color: '#ee5050' }}>(-) {Number(this.state.payment?.list?.total) - (Number(this.state.payment?.balanceDue) ?? 0)}</p>
                                                        <p className="text-small text-end mb-2" style={{ borderTop: '1px solid #eee', padding: '5px 0px' }}>{this.state.payment?.balanceDue}</p> */}


                            </div>
                        </div>
                    </div>


                </div>
            </div>
        )
    }
}

export default UnpaidInvoicesInput;